import * as React from "react";
import { Typography, Box, Card, CardContent, useMediaQuery, useTheme } from "@mui/material";
import { connect } from "react-redux";
import { Table, Tag } from "antd";
import { useSearchParams } from "react-router-dom";
import { centered_flex_box } from "../../app/components/Styles";
import { getTickets } from "../../app/store/actions/imsAdminActions";
import { useEffect } from "react";
import moment from "moment";
import {
  antTableWrapperSx,
  defaultPaginatedTableProps,
  idTableColumn,
} from "../../app/components/AntTableStyles";

export const TicketsList = ({ getTickets, tickets, isLoading }) => {
  const [searchParams] = useSearchParams();
  const ops = searchParams.get("ops") || "delayed";
  const [page, setPage] = React.useState(1);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    getTickets({
      page,
      limit: 50,
      ops: ops === "delayed" ? "delayed" : undefined,
    });
  }, [page, ops, getTickets]);

  const columns = [
    idTableColumn({ title: "ID", dataIndex: "_id" }),
    { title: "Subject", dataIndex: "subject" },
    { title: "Type", dataIndex: "ticketType" },
    { title: "Subtype", dataIndex: "ticketSubtype" },
    { title: "Vendor", dataIndex: "vendor" },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <Tag color={status === "In Progress" ? "blue" : "gold"}>
          {(status || "").toUpperCase()}
        </Tag>
      ),
    },
    { title: "Created", dataIndex: "createdAt" },
  ];

  const data = (tickets?.docs || []).map((row) => ({
    key: row._id,
    _id: row._id,
    subject: row.subject,
    ticketType: row.ticketType,
    ticketSubtype: row.ticketSubtype,
    vendor: row.relevantVendor?.name || "N/A",
    status: row.status,
    createdAt: row.createdAt ? moment(row.createdAt).format("lll") : "",
  }));

  return (
    <div>
      <Box sx={{ width: "100%", padding: 5, mt: 2 }}>
        <Box sx={{ ...centered_flex_box, mb: 2, justifyContent: "space-between" }}>
          <Typography variant="h4" sx={{ color: "var(--secColor)" }}>
            {ops === "delayed" ? "Delayed Tickets" : "Tickets"}
          </Typography>
        </Box>
        {ops === "delayed" && (
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography color="text.secondary">
                Open tickets (Pending or In Progress) older than 2 working days (Friday off), created from 1 June 2026 onward.
              </Typography>
            </CardContent>
          </Card>
        )}
        <Box sx={antTableWrapperSx(isMobile)}>
          <Table
            columns={columns}
            dataSource={data}
            loading={isLoading}
            pagination={defaultPaginatedTableProps({
              current: page,
              pageSize: parseInt(tickets?.limit || 50),
              total: tickets?.totalDocs,
              onChange: (nextPage) => setPage(nextPage),
              itemLabel: "tickets",
            })}
            scroll={{ x: isMobile ? 300 : 1000 }}
          />
        </Box>
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  tickets: state?.records?.tickets,
});

const mapDispatchToProps = { getTickets };

export default connect(mapStateToProps, mapDispatchToProps)(TicketsList);
